import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

// @ts-ignore
import Typewriter from 't-writer.js';

@Component({
  selector: 'app-typewriter',
  template: `<span #twContainer></span>`,
})
export class TypewriterComponent implements AfterViewInit {
  @Input() text: string = '';
  @ViewChild('twContainer', { static: true }) container!: ElementRef<HTMLSpanElement>;

  ngAfterViewInit(): void {
    // Разделяем строку по пробелу
    const slogans = this.text.split(' ');

    const writer = new Typewriter(this.container.nativeElement, {
      loop: true,           // чтобы они чередовались
      typeSpeed: 80,
      deleteSpeed: 40,
      typeColor: '#2B75DB',
      cursorColor: '#2B75DB',
    });

    slogans.forEach((slogan) => {
      writer
        .type(slogan)
        .rest(2500)
        .remove(slogan.length);
    });

    writer.start();
  }
}